import type { PublicCollectionData } from '@mogul/api-client/src/api';
import type { FC } from 'react';
import { useHistory } from 'react-router';

import styles from './CollectionCard.module.css';

interface CollectionCardProps {
  collectionData: PublicCollectionData;
}

export const CollectionCard: FC<CollectionCardProps> = ({ collectionData }) => {
  const history = useHistory();

  const handleClick = () => {
    const network =
      collectionData.network === 'MAINNET' ||
      collectionData.network === 'RINKEBY' ||
      collectionData.network === 'GOERLI'
        ? 'eth'
        : 'bsc';
    history.push('/platform/collection/' + network + '/' + collectionData.slug);
  };

  return (
    <div
      className={
        styles.cardContainer + ' w-full flex flex-col gap-4 box-border relative'
      }
    >
      <img
        className={styles.logoSquarify + ' w-full'}
        src={collectionData.logoImageUrl ?? undefined}
        alt="logoImg"
      />
      <div className={styles.hoverControl}>
        <div className={styles.hoverButtons}>
          <div
            aria-hidden
            className={
              styles.viewButton +
              ' w-full font-semibold flex justify-center items-center cursor-pointer'
            }
            onClick={handleClick}
          >
            VIEW COLLECTION
          </div>
        </div>
      </div>
    </div>
  );
};
